import { AppointmentsState } from "../models/appointments.models";

export const initialAppointmentsState: AppointmentsState = {
    isLoading: false,
    appointments: [],
    currentAppointmentId: undefined,
};
